import { render } from "./WhatsAppView.vue?vue&type=template&id=07fbf184&scoped=true"
import script from "./WhatsAppView.vue?vue&type=script&lang=js"
export * from "./WhatsAppView.vue?vue&type=script&lang=js"

import "./WhatsAppView.vue?vue&type=style&index=0&id=07fbf184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fbf184"]])

export default __exports__